
document.addEventListener('DOMContentLoaded', () => {
    initProgressBar();
    initStickyPanel();
    initSummary();
    initSliderTab();
});


function initSummary() {

    const container = document.querySelector(".cdv-blog");
    if (!container) {
        return;
    }

    const list = document.querySelector(".cdv-blog-summary-list");
    if (!list) {
        return;
    }

    const headings = container.querySelectorAll("h2");
    if (!headings || headings.length === 0) {
        return;
    }

    // Exclure les h2 dans les modales / popups (ex. modal-agency-details)
    const modalSelectors = ".modal-agency-details, .modal-offcanvas, [id^='modal-']";
    const headingsInContent = Array.from(headings).filter((h2) => {
        return !h2.closest(modalSelectors);
    });
    if (headingsInContent.length === 0) {
        return;
    }

    const headerElement = document.querySelector(".cdv-header");
    const headerOffset = headerElement ? headerElement.offsetHeight : 40;
    const offsetMobile = headerOffset + 50;

    const summaryQcdElements = [];

    headingsInContent.forEach((h2, index) => {
        if (!(h2 instanceof HTMLElement)) return;

        if (!h2.id || typeof h2.id !== "string") {
            h2.id = "section-" + (index + 1);
        }

        const li = document.createElement("li");
        if (!li) return;

        const span = document.createElement("span");
        if (!span) return;

        span.className = "qcd";
        span.setAttribute("data-qcd", btoa("#" + h2.id));
        span.setAttribute("data-qcd-offset", String(headerOffset));
        span.setAttribute("data-qcd-offset-mobile", String(offsetMobile));
        span.textContent = h2.textContent || "Section " + (index + 1);

        summaryQcdElements.push(span);
        li.appendChild(span);
        list.appendChild(li);
    });

    if (typeof window.bindQcdElements === "function") {
        window.bindQcdElements(summaryQcdElements);
    }

    // ---- TOGGLE OUVRIR / FERMER LE SOMMAIRE ----
    const title = document.querySelector(".cdv-blog-summary-section-title");
    if (!title) {
        return;
    }
    const arrow = title.querySelector(".cdv-blog-summary-arrow");

    let opened = true;

    title.addEventListener("click", () => {
        opened = !opened;

        if (opened) {
            list.classList.remove("closed");
            if (arrow) arrow.classList.remove("rotated"); 
            if (title) title.classList.remove("rotated"); 
        } else {
            list.classList.add("closed");
            if (arrow) arrow.classList.add("rotated");
            if (title) title.classList.add("rotated"); 
        }
    });
}

function initProgressBar() {
    const post = document.querySelector('.cdv-blog');
    const progressBar = document.getElementById('progress-bar');
    if (!post || !progressBar) return;

    let currentProgress = 0;
    let targetProgress = 0;
    let ticking = false;

    const updateProgressBar = () => {
        currentProgress += (targetProgress - currentProgress) * 0.1;
        progressBar.style.width = `${currentProgress}%`;

        if (Math.abs(targetProgress - currentProgress) > 0.1) {
            requestAnimationFrame(updateProgressBar);
        } else {
            ticking = false;
        }
    };

    const onScroll = () => {
        const maxScroll = post.clientHeight - window.innerHeight;
        if (maxScroll <= 0) return;
        targetProgress = Math.min((window.scrollY / maxScroll) * 100, 100);
        if (!ticking) {
            ticking = true;
            requestAnimationFrame(updateProgressBar);
        }
    };

    window.addEventListener('scroll', onScroll);
}

function initStickyPanel() {
    const panel = document.querySelector('.cdv-sticky-panel-blog');
    const header = document.querySelector('.cdv-header-hidden');
    if (!panel || !header) return;

    const stickyClass = 'is-sticky';
    const originalOffsetTop = panel.offsetTop;

    function handleScroll() {
        if (window.scrollY >= originalOffsetTop) {
            panel.classList.add(stickyClass);
            header.classList.add('hidden-fade');
        } else {
            panel.classList.remove(stickyClass);
            header.classList.remove('hidden-fade');
        }
    }

    window.addEventListener('scroll', handleScroll);
    handleScroll();
}

function initSliderTab() {
    const buttons = document.querySelectorAll(".cdv-slider-filters button");
    const items = document.querySelectorAll(".cdv-tab-item");

    buttons.forEach(btn => {
        btn.addEventListener("click", () => {

            buttons.forEach(b => b.classList.remove("cdv-btn-active"));
            btn.classList.add("cdv-btn-active");

            const tabIndex = btn.dataset.filter;
            items.forEach(item => {
                if (item.dataset.tab === tabIndex) {
                    item.style.display = "block";
                } else {
                    item.style.display = "none";
                }
            });
        });
    });
}



